/**
 * Admin Dashboard Configuration - EMERGENCY FALLBACKS ONLY
 * 
 * ⚠️ WARNING: DO NOT EDIT THESE VALUES DIRECTLY ⚠️
 * 
 * These are EMERGENCY FALLBACK VALUES used only if the database is unavailable.
 * The database (MongoDB ConfigSettings collection) is the source of truth.
 * 
 * To update these configurations:
 * 1. Log in as admin at /admin
 * 2. Navigate to "Configuration Settings" section
 * 3. Edit values through the admin dashboard UI
 * 
 * These static values should only be updated if you need to change the 
 * emergency fallback defaults for a catastrophic database failure scenario.
 */

export const AVAILABLE_COURSES = [
  { id: 'itws1100', name: 'ITWS 1100 - Intro to IT & Web Science' }
];

export const ROLE_OPTIONS = [
  { value: 'user', label: 'User' },
  { value: 'student', label: 'Student' },
  { value: 'admin', label: 'Admin' }
];

export const LANDING_PAGE_OPTIONS = [
  { value: '/', label: 'Home Page' },
  { value: '/teaching', label: 'Teaching/Course Page' },
  { value: '/admin', label: 'Admin Dashboard' }
];
